import script from "./AccordionBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionBlock.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionBlock.vue?vue&type=style&index=0&id=527dc808&lang=scss"

const __exports__ = script;

export default __exports__